/* istanbul ignore file */
import { REFUND_METHOD } from 'config';

const getPreviousCredit = (returnDetails, res) => {
  if (returnDetails?.creditedAmount && returnDetails?.creditedAmount !== 0.0) {
    res.previousCreditFlag = true;
    res.previousCreditMessage = 'Previous credit amount';
    res.previousCreditAmount = returnDetails?.creditedAmount;
    if (returnDetails.estimatedRefund >= 0) {
      res.estimatedCreditMessage = 'Estimated credit remaining';
    }
  }
};

const estimatedCredit = (data, isReturnlessRefund = false) => {
  const returnDetails = isReturnlessRefund ? data.rpShipments[0] : data;

  const res = {};
  res.previousCreditFlag = false;
  res.originalPaymentFlag = false;
  res.gifCardMessageFlag = false;
  res.storeCreditMessageFlag = false;
  res.refundToOriginalPaymentFlag = false;
  res.estimatedCreditMessage = 'Estimated refund';

  getPreviousCredit(data, res);

  if (returnDetails?.estimatedRefund < 0) {
    res.estimatedCreditMessage = 'Estimated charge';
  }

  res.estimatedCreditAmount = returnDetails.estimatedRefund;

  if (returnDetails) {
    res.returnsRefundMethodEnabledFlag = true;
    res.refundToMessage = 'Refund To';
    if (returnDetails.refundMethod === REFUND_METHOD.GIFT) {
      res.giftCardMessageFlag = true;
    } else if (returnDetails.refundMethod === REFUND_METHOD.EGIFT) {
      res.eGiftCardMessageFlag = true;
    } else if (returnDetails.refundMethod === REFUND_METHOD.ORIGINAL && returnDetails.refundToAccountType && returnDetails.refundToAccountNumber) {
      res.originalPaymentFlag = true;
      res.refundToAccount =
        returnDetails?.refundToAccountType?.toUpperCase() === 'KLARNA'
          ? `${returnDetails.refundToAccountType}`
          : `${returnDetails.refundToAccountType} ${returnDetails.refundToAccountNumber}`;
      res.refundToAccountNumber = returnDetails?.refundToAccountType?.toUpperCase() !== 'KLARNA' ? returnDetails.refundToAccountNumber : '';
    } else if (returnDetails.refundMethod === REFUND_METHOD.WALLET) {
      res.storeCreditMessageFlag = true;
    } else {
      res.refundToOriginalPaymentFlag = true;
      res.refundToOriginalPayment = 'Original Payment Method';
    }
  }
  return res;
};

export default estimatedCredit;
